import React from 'react'
import { Divider, Widget, WidgetContent } from '@duik/it'
import { ModalButton } from '../../UI/ModalButton'
import SmConfirmModal from '../../UI/SmConfirmModal'
import CloseIcon from '@material-ui/icons/ClearRounded'

const LoadDeleteModal = props => {
  return (
    <SmConfirmModal>
      <Widget style={{ width: '100%', height: '100%' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <h3 style={{ margin: '25px', color: 'black' }}>Delete Load</h3>
          <CloseIcon onClick={props.loadDeleteModalToggle} className="closeIcon" />
        </div>
        <Divider />
        <WidgetContent>
          <p style={{ margin: 0, fontSize: '16px', color: 'black' }}>
            Are you sure you want to delete this load?
          </p>
        </WidgetContent>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            margin: '0 25px'
          }}
        >
          <div style={{ width: '83px' }}>
            <ModalButton
              buttonStyle="tertiary"
              name="Cancel"
              onClick={props.loadDeleteModalToggle}
            />
          </div>
          <div style={{ width: '83px' }}>
            <ModalButton
              success
              type="submit"
              onClick={() => props.deleteLoad(props.loadDeleteDetail._id)}
              name="OK"
            />
          </div>
        </div>
      </Widget>
    </SmConfirmModal>
  )
}

export default LoadDeleteModal
